:root {
  --kh-red:          #ED1943;
  --kh-red-dark:     #CB163A;
  --kh-red-dim:      rgba(237, 25, 67, 0.12);
  --kh-red-border:   rgba(237, 25, 67, 0.3);

  --kh-bg:           #CB163A;
  --kh-surface:      #FFFFFF;
  --kh-surface-2:    #FEF5F7;
  --kh-border:       rgba(200, 30, 65, 0.1);
  --kh-border-hover: rgba(200, 30, 65, 0.25);
  --kh-off-white:    #FEF5F7;

  --kh-text-primary:   #0C0C0C;
  --kh-text-secondary: #555555;
  --kh-text-muted:     #888888;

  --kh-teal:         #1A8C68;
  --kh-teal-dim:     rgba(26, 140, 104, 0.1);
  --kh-blue:         #2E7FCC;
  --kh-blue-dim:     rgba(46, 127, 204, 0.1);
  --kh-purple:       #6E68CC;
  --kh-purple-dim:   rgba(110, 104, 204, 0.1);
  --kh-amber:        #CC8C1A;
  --kh-amber-dim:    rgba(204, 140, 26, 0.1);
  --kh-coral:        #CC4E28;
  --kh-coral-dim:    rgba(204, 78, 40, 0.1);
  --kh-orange:       #CC6A1A;
  --kh-orange-dim:   rgba(204, 106, 26, 0.1);
  --kh-pink:         #B84070;
  --kh-pink-dim:     rgba(184, 64, 112, 0.1);

  --kh-font:           'Helvetica Neue', Helvetica, Arial, sans-serif;
  --kh-font-mono:      'SF Mono', 'Cascadia Code', 'Consolas', 'Monaco', monospace;
  --kh-font-wordmark:  700;
  --kh-font-heading:   700;
  --kh-font-label:     500;
  --kh-font-body:      400;

  --kh-size-wordmark:  18px;
  --kh-size-heading:   30px;
  --kh-size-label:     11px;
  --kh-size-card-name: 15px;
  --kh-size-body:      14px;
  --kh-size-meta:      12px;

  --kh-ls-wordmark:    0.08em;
  --kh-ls-heading:     -0.02em;
  --kh-ls-label:       0.1em;

  --kh-radius-card:    10px;
  --kh-radius-sm:      6px;
  --kh-radius-icon:    9px;
  --kh-radius-badge:   4px;

  --kh-shadow-1:     0 1px 4px rgba(0, 0, 0, 0.18), 0 0 0 0.5px rgba(0, 0, 0, 0.06);
  --kh-shadow-2:     0 4px 20px rgba(0, 0, 0, 0.25), 0 0 0 0.5px rgba(0, 0, 0, 0.08);
  --kh-shadow-modal: 0 20px 60px rgba(0, 0, 0, 0.5), 0 8px 24px rgba(0, 0, 0, 0.22);

  --kh-space-1: 4px;  --kh-space-2: 8px;  --kh-space-3: 12px; --kh-space-4: 16px;
  --kh-space-5: 20px; --kh-space-6: 24px; --kh-space-7: 32px; --kh-space-8: 48px;

  --kh-topbar-height:  52px;

  --kh-ease-out:    cubic-bezier(0.16, 1, 0.3, 1);
  --kh-ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
  --kh-duration-fast:  120ms;
  --kh-duration-base:  200ms;
  --kh-duration-slow:  400ms;
}
